<template>
  <v-dialog
    v-model="dialogLearn"
    @keydown.esc="closeLearn"
    persistent
    scrollable
    content-class="medium"
  >
    <v-card>
      <v-card-title>
        <span class="headline">NLU result</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <div class="borderTop1">
                <div v-if="Object.keys(jsonView).length > 0">
                  <json-viewer
                    v-model="logNluResult"
                    :expand-depth="4"
                    copyable
                    boxed
                    expanded
                  ></json-viewer>
                </div>
              </div>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              If the above prediction is not correct, you can add new phrase
              here.<br />
              One done, you will need to build model to train the newly added
              phrases.
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" class="d-flex p-t-0 p-b-0">
              <div class="m-auto m-r-20 width100px">Phrase</div>
              <v-text-field
                v-model="phrase"
                class="m-b-10"
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" class="d-flex p-t-0 p-b-0">
              <div class="m-auto m-r-20 width100px">Tag as intent</div>
              <v-autocomplete
                class="m-b-10"
                v-model="selectedIntent"
                :items="intents"
                item-text="name"
                item-value="_id"
                label=""
                dense
                hide-details
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
              class="d-flex p-t-0 p-b-0 m-t-10"
            >
              <v-switch
                v-model="isTraining"
                :label="
                  isTraining
                    ? 'Assign to training set'
                    : 'Don’t assign to any dataset (i.e. left dataset blank)'
                "
                inset
                dense
                hide-details
              ></v-switch>
            </v-col>
          </v-row> -->
        </v-container>
      </v-card-text>

      <!-- <div id="error" class="red--text text-center">
        {{ errorMessage }}
      </div> -->

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn id="btn-ok" class="btn-primary" text @click="closeLearn">
          OK
        </v-btn>
        <!-- <v-btn id="btn-close" class="btn-secondary" text @click="closeLearn"
          >Cancel</v-btn
        >
        <v-btn id="btn-ok" class="btn-primary" text @click="saveLearn"
          >Learn</v-btn
        > -->
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialoaLearning',
  props: {
    dialogLearn: Boolean,
    logNluResult: Object,
    word: String,
    intents: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      column: 'tag',
      phrase: '',
      selectedIntent: undefined,
      isTraining: true,
      errorMessage: '',
      jsonView: {}
    }
  },
  created() {
    this.phrase = this.word
  },
  watch: {
    logNluResult: {
      immediate: true,
      deep: true,
      handler(val) {
        setTimeout(() => {
          this.jsonView = val
        }, 500)
      }
    }
  },
  methods: {
    closeLearn() {
      this.$emit('closeLearn', null)
    },
    saveLearn() {
      if (!this.phrase) {
        this.errorMessage = 'Phrase is required'
        return
      }
      if (!this.selectedIntent) {
        this.errorMessage = 'Intent is required'
        return
      }

      this.$emit('saveLearn', {
        name: this.phrase.trim(),
        intent_id: this.selectedIntent,
        status: this.isTraining ? 'ok' : ''
      })
    }
  }
}
</script>

<style scoped lang="scss">
.borderTop1 {
  height: calc(100vh - 300px);
  overflow-y: scroll;
  background-color: white;
  border: 1px solid;
  border-color: #ebebeb;
  padding: 15px 0px 15px 15px;
}
.width100px {
  width: 100px;
}
</style>
